import React, {useContext, useEffect, useState} from 'react'
import {Grid, FormControl, InputLabel, TextField, FormHelperText} from '@material-ui/core'
import moment from 'moment'
import {DateTimePicker} from '@material-ui/pickers'
import {ReservationContext} from '../../../../context/Reservation'
export default function WDateTimeField({data, onChange}) {
  console.log(data)
  const [value, setValue] = useState(data.value)
  const {configuration} = useContext(ReservationContext)
  let timeFormat = configuration.data.date_format
  if (timeFormat?.includes('%I:%M %p')) {
    timeFormat = 'YYYY-MM-DD hh:mm A'
  } else if (timeFormat.includes('%r')) {
    timeFormat = 'YYYY-MM-DD hh:mm:ss A'
  } else if (timeFormat.includes('%R')) {
    timeFormat = 'YYYY-MM-DD HH:mm'
  } else if (timeFormat.includes('%T')) {
    timeFormat = 'YYYY-MM-DD HH:mm:ss'
  }
  useEffect(() => {
    console.log(data)
    if (data?.default_value?.value) {
      if (data.default_value.value === 'date_today') {
        let e = {
          target: {
            value: moment()
              .local()
              .format('YYYY-MM-DDThh:mm:ss'),
          },
        }
        if (data.default_value.op === 'add') {
          e.target.value = moment()
            .clone()
            .add(data.default_value.days, 'days')
            .add(data.default_value.months, 'months')
            .add(data.default_value.years, 'years')
            .local()
            .format('YYYY-MM-DDThh:mm:ss')
        } else if (data.default_value.op === 'subtract') {
          e.target.value = moment()
            .clone()
            .subtract(data.default_value.days, 'days')
            .subtract(data.default_value.months, 'months')
            .subtract(data.default_value.years, 'years')
            .local()
            .format('YYYY-MM-DDThh:mm:ss')
        }
        onChange(e, 'value', data)
      }
    }
    return () => {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])
  return (
    <Grid item xs={6}>
      <FormControl fullWidth variant="outlined" className="ap-textfield" style={{width: 320}}>
        <DateTimePicker
          ampm={
            timeFormat === 'YYYY-MM-DD hh:mm A' || timeFormat === 'YYYY-MM-DD hh:mm:ss A'
              ? true
              : false
          }
          label={data.name}
          inputVariant="outlined"
          value={value}
          format={timeFormat}
          onChange={e => {
            setValue(e)
            onChange(e, 'value', data)
          }}
          renderInput={params => <TextField {...params} />}
        />
        <FormHelperText>{!data.is_required ? 'optional' : ''}</FormHelperText>
      </FormControl>
    </Grid>
  )
}